import { cn } from '../../../utils/string/cn.utils';

const CardCategory = ({
  label,
  description,
  icon,
  actived,
  onClick,
  ...props
}) => {
  return (
    <div
      {...props}
      onClick={onClick}
      className={cn(
        'grid grid-cols-3 lg:w-full min-w-[177px] py-[8px] lg:px-[24px] px-[16px] self-stretch items-center content-center lg:gap-[8px] lg:flex-wrap lg:rounded-[16px] rounded-[8px] bg-fills-primary text-black-high hover:bg-primary-primary hover:text-white transition-all cursor-pointer duration-300',
        actived && 'bg-primary-primary text-white',
        props.className
      )}
    >
      <div className="col-span-2 flex flex-col items-start justify-center gap-[4px] grow self-stretch">
        <span className="lg:text-title-medium text-title-small !font-bold line-clamp-2">
          {label}
        </span>
        <span className="text-body-medium">{description}</span>
      </div>
      <div className="col-span-1 flex lg:w-[80px] lg:h-[80px] w-[48px] h-[48px] flex-shrink-0 aspect-square">
        {icon}
      </div>
    </div>
  );
};

export default CardCategory;
